import styled from "styled-components";

import { Box } from "@vinomofo/components";

import preloadLogo from "./preload-logo.png";

import type { ReactElement } from "react";

const Placeholder = styled(Box)`
  display: flex;
  align-items: center;
  position: relative;
  padding-top: 100%;
  width: 100%;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  background-image: url(${preloadLogo});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 80%;
  background-color: ${({ theme }) => theme.colors.almostWhite};
`;

const PlaceholderImage = (): ReactElement => {
  return <Placeholder />;
};

export default PlaceholderImage;
